<template>
  <div class="detail_main bg_detail is-scrollable has-background-white">
    <div class="detail_img_info" v-if="detailFace.listeFaces.length">
      <div class="level is-mobile diapo_mount">
        <div class="level-left is-marginless">
          <a class="button has-text-white is-rounded diapo_button"
            @click="$parent.show = false">
            <span class="icon">
              <b-icon icon="chevron-left"></b-icon>
            </span>
            <label>Retour</label>
          </a>
        </div>
        <div class="level-right">
          <div class="button has-text-white is-rounded rightViolet diapo_count">
            <label>{{currentImg + 1}}/{{detailFace.listeFaces.length}}</label>
          </div>
        </div>
      </div>
      <img
        :src="url(img)"
        class="imageBgOpp imgGoToTop"
        v-touch:swipe.left="swipeLeft()"
        v-touch:swipe.right="swipeRight()">
    </div>
    <div class="detail_img_info" v-else>
      <a class="button has-text-white is-rounded diapo_button"
        @click="$parent.show = false">
        <span class="icon">
          <b-icon icon="chevron-left"></b-icon>
        </span>
        <label>Retour</label>
      </a>
      <img :src="url(detailFace.urlPhoto)" class="imageBgOpp imgGoToTop">
    </div>
    <div class="leftVert topViolet rightVert bottomVert">
      <div class="tabs bottomVert">
        <ul class="p_size12 has-text-weight-bold">
          <li :class="{'underline is-active': active === 1}"
              @click="active = 1"
              class="is-paddingless">
            <a>Proposition</a>
          </li>
          <li :class="{'underline is-active': active === 2}"
              @click="active = 2"
              class="is-paddingless">
            <a>Caractéristiques</a>
          </li>
        </ul>
      </div>
      <div v-if="active === 1">
        <div class="bottomViolet">
          <div class="media color-icon">
            <b-icon
              icon="timer"
              size="is-medium"
              class="media-left">
            </b-icon>
            <div class="media-content has-text-link is-size-7">
                <label class=" has-text-grey">
                  Période d'affichage :
                </label><br>
                <p class="p_size12 has-text-weight-bold">
                  {{periode}}
                </p>
            </div>
          </div>
        </div>
        <div class="columns is-mobile is-marginless is-multiline color-icon detail_content_propo">
          <div
            v-if="detailFace.extensionOpportunite.tarifHT"
            class="column is-6 is-paddingless bottomViolet">
            <div class="media">
              <b-icon
                icon="cash"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content has-text-link is-size-7">
                <label class=" has-text-grey">
                  Tarif brut HT
                </label><br>
                <p class="p_size12 has-text-weight-bold">
                  {{calTarif(detailFace.extensionOpportunite.tarifHT)}}
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="detailFace.extensionOpportunite.tarifNet"
            class="column is-6 is-paddingless bottomViolet">
            <div class="media">
              <b-icon
                icon="cash"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content has-text-link is-size-7">
                <label class=" has-text-grey">
                  Tarif net HT
                </label><br>
                <p class="p_size12 has-text-weight-bold">
                  {{calTarif(detailFace.extensionOpportunite.tarifNet)}}
                </p>
                <span class="has-text-grey is-italic"
                  v-if="detailFace.extensionOpportunite.masquerRemiseEdition === true
                    && this.detailFace.extensionOpportunite.remise">
                  {{this.detailFace.extensionOpportunite.remise}} {{typeRemise}}
                </span>
              </div>
            </div>
          </div>
          <div
            v-if="detailFace.extensionOpportunite.tarifDePose"
            class="column is-6 is-paddingless bottomViolet">
            <div class="media">
              <b-icon
                icon="sign-text"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content has-text-link is-size-7">
                <label class=" has-text-grey">
                  Tarif de pose Ht
                </label><br>
                <p class="p_size12 has-text-weight-bold">
                  {{calTarif(detailFace.extensionOpportunite.tarifDePose)}}
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="detailFace.extensionOpportunite.tarifImpression"
            class="column is-6 is-paddingless bottomViolet">
            <div class="media">
              <b-icon
                icon="printer"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content has-text-link is-size-7">
                <label class=" has-text-grey">
                  Tarif d'impression HT
                </label><br>
                <p class="p_size12 has-text-weight-bold">
                  {{calTarif(detailFace.extensionOpportunite.tarifImpression)}}
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="detailFace.extensionOpportunite.taxeMunicipale"
            class="column is-6 is-paddingless bottomViolet">
            <div class="media">
              <b-icon
                icon="ballot"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content has-text-link is-size-7">
                <label class=" has-text-grey">
                  Taxes municipales
                </label><br>
                <p class="p_size12 has-text-weight-bold">
                  {{calTarif(detailFace.extensionOpportunite.taxeMunicipale)}}
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="detailFace.extensionOpportunite.fraisTecniques"
            class="column is-6 is-paddingless bottomViolet">
            <div class="media">
              <b-icon
                icon="panorama-wide-angle"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content has-text-link is-size-7">
                <label class=" has-text-grey">
                  Frais techniques
                </label><br>
                <p class="p_size12 has-text-weight-bold">
                  {{calTarif(detailFace.extensionOpportunite.fraisTecniques)}}
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="detailFace.extensionOpportunite.facesSouhaitees"
            class="column is-6 is-paddingless bottomViolet">
            <div class="media">
              <b-icon
                icon="panorama-wide-angle"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content has-text-link is-size-7">
                <label class=" has-text-grey">
                  Faces souhaitées
                </label><br>
                <p class="p_size12 has-text-weight-bold">
                  {{detailFace.extensionOpportunite.facesSouhaitees}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="detailFace.extensionOpportunite.commentaire">
          <p class=" p_size12has-text-link has-text-weight-bold topViolet bottomViolet">
            Commentaire:
          </p>
          <div class="commentaire">
            <p class="has-text-link has-text-justify p_size11">
              {{detailFace.extensionOpportunite.commentaire}}
            </p>
          </div>
        </div>
      </div>
      <div v-if="active === 2">
        <label class="has-text-grey">
          Nom du réseau
        </label>
        <p class="p_size12 has-text-weight-bold bottomViolet">
          {{detailFace.libelle}}
        </p>
        <div class="columns is-mobile is-multiline color-icon">
          <div class="column is-6">
            <div class="media">
              <b-icon
                icon="city"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content has-text-link is-size-7">
                <label class="has-text-grey ">
                  Ville
                </label><br>
                <p class="p_size12 has-text-weight-bold">
                  {{detailFace.ville}}
                </p>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="media">
              <b-icon
                icon="vector-intersection"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content has-text-link is-size-7">
                <label class="has-text-grey ">
                  Format
                </label><br>
                <p class="p_size12 has-text-weight-bold">
                  {{detailFace.format}}
                </p>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="media">
              <b-icon
                icon="sign-text"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content has-text-link is-size-7">
                <label class=" has-text-grey">
                  Nombre de faces
                </label><br>
                <p class="p_size12 has-text-weight-bold">
                  {{detailFace.nbFaces}}
                </p>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="media">
              <b-icon
                icon="calendar"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content has-text-link is-size-7">
                <label class="has-text-grey ">
                  Jour de depart
                </label><br>
                <p class="p_size12 has-text-weight-bold">
                  {{jour[detailFace.jourDepart]}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!detailFace.select" @click="contolSelect()"
         class="navbar is-fixed-bottom button is-primary boutonSelectM has-text-weight-bold">
      <p class="p_size11 centreM">Ajouter a ma sélection</p>
    </div>
    <div v-else @click="contolSelect()"
         class="navbar is-fixed-bottom button boutonRed boutonSelectM has-text-weight-bold">
      <p class="p_size11 centreM">Retirer de ma sélection</p>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { calPeriode, urlPhoto, formatNum, jrSem } from '@/services/opportunite/formatTab';

export default {
  name: 'detailTempoDiapo',
  props: ['detailFace'],
  data() {
    return {
      active: 1,
      select: true,
      currentImg: 0,
    };
  },
  computed: {
    periode() {
      if (this.detailFace.extensionOpportunite.newPeriode) {
        return this.detailFace.extensionOpportunite.newPeriode;
      }
      const d = this.detailFace.extensionOpportunite.jourDepart;
      const w = this.detailFace.extensionOpportunite.semaine;
      const y = this.detailFace.extensionOpportunite.annee;
      return calPeriode(d, w, y);
    },
    jour() {
      return jrSem;
    },
    img() {
      return this.detailFace.listeFaces[this.currentImg].urlPhoto;
    },
    typeRemise() {
      if (this.detailFace.extensionOpportunite.typeDeRemise === 0) {
        return '% de remise inclus';
      }
      return '€ de remise inclus';
    },
    getTarif() {
      let tarifNet = 0;
      let tarifDePose = 0;
      let taxeMunicipale = 0;
      let tarifImpression = 0;
      let tarifHT = 0;
      if (this.detailFace.extensionOpportunite.tarifDePose) {
        tarifDePose = this.detailFace.extensionOpportunite.tarifDePose;
      }
      if (this.detailFace.extensionOpportunite.taxeMunicipale) {
        taxeMunicipale = this.detailFace.extensionOpportunite.taxeMunicipale;
      }
      if (this.detailFace.extensionOpportunite.tarifImpression) {
        tarifImpression = this.detailFace.extensionOpportunite.tarifImpression;
      }
      if (this.detailFace.extensionOpportunite.tarifHT) {
        tarifHT = this.detailFace.extensionOpportunite.tarifHT;
      }
      if (this.detailFace.extensionOpportunite.tarifNet) {
        tarifNet = this.detailFace.extensionOpportunite.tarifNet;
        return tarifNet
        + tarifDePose
        + taxeMunicipale
        + tarifImpression;
      }
      return tarifHT
        + tarifDePose
        + taxeMunicipale
        + tarifImpression;
    },
  },
  methods: {
    ...mapActions([
      'add',
      'substract',
      'addNbSelect',
      'substractNbSelect',
    ]),
    url(data) {
      return urlPhoto(data);
    },
    contolSelect() {
      this.detailFace.select = !this.detailFace.select;
      if (this.detailFace.select) {
        this.add(this.getTarif);
        this.addNbSelect();
      } else {
        this.substract(this.getTarif);
        this.substractNbSelect();
      }
    },
    calTarif(t) {
      return formatNum(t);
    },
    swipeLeft() {
      return () => {
        if (this.currentImg === this.detailFace.listeFaces.length - 1) {
          this.currentImg = 0;
        } else {
          this.currentImg += 1;
        }
      };
    },
    swipeRight() {
      return () => {
        if (this.currentImg === 0) {
          this.currentImg = this.detailFace.listeFaces.length - 1;
        } else {
          this.currentImg -= 1;
        }
      };
    },
  },
  mounted() {
    const test = document.querySelector('html');
    const test2 = document.querySelector('body');
    test.style.overflow = 'hidden';
    test2.style.overflow = 'hidden';
  },
  destroyed() {
    const test = document.querySelector('html');
    const test2 = document.querySelector('body');
    test.style.overflow = '';
    test2.style.overflow = '';
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/ismobile/propositions/reseauxTempo/detailTempoDiapo.vue